export default {
  /**
   * Sở chủ quản phân bổ  bổ sung bổ sung chi thường xuyên
   */
  SCQ_Regular: 10,

  /**
   * Sở chủ quản phân bổ  bổ sung chi chương trình mục tiêu
   */
  SCQ_Program: 20,

  /**
   * Sở chủ quản phân bổ  bổ sung chờ phân bổ
   */
  SCQ_Pending_Allocation: 30,

  /**
   * SCQ phân bổ bổ sung thu HĐSN
   */
  SCQ_Revenue_Business: 40,

  /**
   * SCQ phân bổ bổ sung chi HĐSN
   */
  SCQ_Expense_Business: 50,

  /**
   * SCQ phân bổ bổ sung thu phí
   */
  SCQ_Revenue_Fees: 60,

  /**
   * SCQ phân bổ  bổ sung chi phí lệ phí
   */
  SCQ_Expense_Fees: 70,

  /**
   * SCQ tổng hợp phân bổ bổ sung nguồn nsnn
   */
  SCQ_Summary_Budget: 80,

  /**
   * SQC tổng hợp Nguồn hoạt động sử nghiệp dịch vụ
   */
  SCQ_Summary_Business: 90,

  /**
   * SCQ tổng hợp phí, lệ phí
   */
  SCQ_Summary_Fees: 100,
};
